<template>
<div>
    <organisationtype :organisationtypes="organisationTypes" @organisationTypeChange="getOrganisationTypes()"></organisationtype>
</div>
  
</template>

<script>
import Api from "@/services/Api";
import OrganisationType from '@/components/OrganisationType.vue';

export default {
    
  components: {
    organisationtype: OrganisationType
  },
  data(){
      return{
          organisationTypes: []
      }
  },
  created(){
      this.initialize()
  },
  methods: {
      initialize(){
          this.getOrganisationTypes()
      },
      getOrganisationTypes(){
          Api()
          .get('/OrganisationType')
          .then(response=>{
              this.organisationTypes=response.data
          })
      }
  }
}
</script>

<style>

</style>